import SiteFooter from "./SiteFooter";
import SiteHeader from "./SiteHeader";

export default function Layout({ path, children }) {
  return (
    <div className="overflow-x-clip">
      <a
        href="#main"
        className="fixed -top-24 left-4 z-100 rounded-xl bg-white px-4 py-3 font-bold text-ink shadow-lift focus:top-3"
      >
        Skip to content
      </a>
      <SiteHeader path={path} />
      <main id="main" tabIndex={-1}>
        {children}
      </main>
      <SiteFooter />
    </div>
  );
}
